module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"gender_rate":"男女比率","gender_desc":"来店したお客様の男女比を表示します。"}}')
  delete Component.options._Ctor
}
